/**
 * @summary     app.dataStore.js
 * @description App JS data store Controller
 * @version     1.0
 	> 1.0 Initial version
		- 08/19/2016 SG
 * @author      Silas Garrison (http://silasgarrison.com/)
 ** EXAMPLES:
 ** NOTE:
 ** TODO:
*/

app.addFeature(
	"dataStore",
	function(){
		"use strict";

		var self = this,
			dataStore = {};

		/*
			Name: init
			Use: API.init()
			Args: none
			Description: initialization
		*/
		self.init = function(){
			var cache = app.localCache.get("dataStore") || dataStore,
				pathEmitter = "dataStoreChange",
				key;

			self.set(cache);

			/*
				NOTE:
					Emit events for each property found in the cache
			*/
			for(key in cache){
				if(cache.hasOwnProperty(key)){
					app.events.emit(
						pathEmitter.append(".").append(key),
						{
							path : pathEmitter.append(".").append(key),
							value : cache[key],
							old : cache[key]
						}
					);
				}
			}
		};

		/*
			Name: set
			Use: API.set()
			Args: path String - The path of the variable (i.e. dataStore."path.to.var")
					value Any - The value we're setting - if undefined it's assumed path is the value and we're overwriting the whole data store
			Description: initialization
		*/
		self.set = function(path,value){
			var newStore = dataStore,
				cache = JSON.clone(newStore),
				pathEmitter = "dataStoreChange";

			if(typeof path !== "string"){
				dataStore = newStore = path;
			}
			else {
				/*
					NOTE:
						Append the event emitted path
				*/
				pathEmitter = pathEmitter.append(".").append(path);
				path = path.split(".");
				path.forEach(
					function(p,idx){
						/*
							NOTE:
								If on the last item in the path, we're now to the value we're setting
						*/
						if(idx + 1 === path.length){
							newStore[p] = value;
						}
						else {
							if(!newStore[p]){
								newStore[p] = {};
							}
							newStore = newStore[p];
						}
					}
				);

				/*
					NOTE:
						newStore is a lower level variable right now, let's reset it to being a pointer
				*/
				newStore = dataStore;
			}

			app.localCache.set("dataStore",newStore);

			/*
				NOTE:
					Emit the event changes for each path in the chain (i.e. dataStoreChange is top level then dataStoreChange.someObj then dataStoreChange.someObj.someAttr)
			*/
			pathEmitter.split(".").forEach(
				function(itm,idx){
					app.events.emit(
						pathEmitter.split(".").slice(0,idx + 1).join("."),
						{
							path : path,
							value : value,
							old : cache
						}
					);
				}
			);

			return self;
		};

		/*
			Name: get
			Use: API.get()
			Args: path String - The path of the variable (i.e. dataStore."path.to.var")
			Description: Gets a variable
		*/
		self.get = function(path){
			var val = app.localCache.get("dataStore") || dataStore;

			if(typeof path === "string"){
				path.split(".").forEach(
					function(p,idx){
						val = val[p];

						if(val === undefined || val === null){
							val = path.split(".").length === idx + 1?null:{};
						}
					}
				);
			}

			try {
				return JSON.clone(val);
			}
			catch(e){
				return val;
			}
		};

		return self;
	}
);
